module.exports = __webpack_public_path__ + "static/media/facebookBlack.432aa729.svg";